<template>
  <v-sheet :min-height="min_height"
           @click="$emit('add')"
           class="dashed-outlined d-flex flex-row justify-center align-center rounded-xl">
    <v-icon small color="#BDBDBD" class="mr-2">fa fa-plus</v-icon>
    <p class="color-text font-weight-bold text-subtitle-1">{{body_text}}</p>
  </v-sheet>
</template>

<script>
export default {
  name: "AddCard",

  props: {
    min_height: {
      Type: String,
      default: '154px'
    },
    body_text: {
      Type: String,
      default: ""
    },
  }
}
</script>

<style scoped>
.dashed-outlined {
  border:2px dashed #BDBDBD !important;
  cursor: pointer;
}

.color-text {
  color: #BDBDBD;
}
</style>